import { service } from '@ember/service';
import type { AsyncBelongsTo } from '@ember-data/model';
import Model, { attr, belongsTo } from '@ember-data/model';
import { dropTask } from 'ember-concurrency';
import type CompanyModel from 'garaje/models/company';
import type LocationModel from 'garaje/models/location';
import type AjaxService from 'garaje/services/ajax';
import type FlashMessagesService from 'garaje/services/flash-messages';
import { parseErrorForDisplay } from 'garaje/utils/flash-promise';
import urlBuilder from 'garaje/utils/url-builder';

export default class AnnouncementModel extends Model {
  @service declare flashMessages: FlashMessagesService;
  @service declare ajax: AjaxService;

  // Relationships
  @belongsTo('company', { inverse: null }) declare company: AsyncBelongsTo<CompanyModel>;
  @belongsTo('location') declare location: AsyncBelongsTo<LocationModel>;

  // Attributes
  @attr('string') declare title: string;
  @attr('string') declare description: string;
  @attr('string') declare link: string;
  @attr('boolean') declare shouldSendPushNotification: boolean;
  @attr('boolean') declare isArchived: boolean;
  @attr('number') declare numSeen: number;
  @attr('date') declare createdAt: Date;

  sendPushNotificationTask = dropTask(async () => {
    const url = urlBuilder.rms.sendAnnouncementNotification(this.id);
    try {
      await this.ajax.request(url, {
        // @ts-ignore accept is not a valid attribute for request options
        accept: 'application/vnd.api+json',
        type: 'POST',
      });
      this.flashMessages.showAndHideFlash('success', 'Message sent!');
    } catch (e) {
      const errorText = parseErrorForDisplay(e);
      this.flashMessages.showFlash('error', errorText);
    }
  });
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    announcement: AnnouncementModel;
  }
}
